import { useState, useContext } from "react";
import { DistributionFilter } from "../fragments.dispatches/DistributionFilter";
import { DistributionList } from "../fragments.dispatches/DistributionList";
import { ContextAuth } from "../../../contexts/ContextAuth";
import { getCurrentDate } from "../../../configs/helpers";

export function DistributionPage() {
    const [orders, setOrders]           = useState([]);
    const [gangs, setGangs]             = useState([]);
    const [users, setUsers]             = useState([]);
    const [filename, setFilename]       = useState("ReporteVentas");
    const [operationStatus]             = useState([
        { id: "02", name: "Comprobantes Generados" },
        { id: "01", name: "Cotizaciones" },
    ]);
    const { auth } = useContext(ContextAuth);

    const [questionState, setQuestionState] = useState({
        startDate:       getCurrentDate("-"),
        endDate:         getCurrentDate("-"),
        subsidiaryID:    auth.data.subsidiary.subsidiary_id,
        warehouseID:     0,
        gangID:          0,
        userID:          0,
        operationStatus: "02",
        documentType:    "02",
        mode:            "01",
        httpStatusCode:  200,
    });

    // Función de búsqueda centralizada — la usan tanto el filtro como la lista
    const [searchFn, setSearchFn] = useState(null);

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div>
                            <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight flex items-center gap-2">
                                <i className="fas fa-truck text-blue-500"></i>
                                Ventas de Reparto
                            </h1>
                            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                                Gestión y seguimiento de distribuciones
                            </p>
                        </div>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">Distribuciones</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">Listado</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4 space-y-4">

                    {/* Filter panel */}
                    <DistributionFilter
                        setOrders={setOrders}
                        gangs={gangs}
                        setGangs={setGangs}
                        users={users}
                        setUsers={setUsers}
                        operationStatus={operationStatus}
                        setFilename={setFilename}
                        questionState={questionState}
                        setQuestionState={setQuestionState}
                        getCurrentDate={getCurrentDate}
                        ordersCount={orders.length}
                        registerSearchFn={setSearchFn}
                    />

                    {/* Results */}
                    <DistributionList
                        orders={orders}
                        filename={filename}
                        questionState={questionState}
                        onRefresh={searchFn}
                    />
                </div>
            </section>
        </>
    );
}
